"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const StoresUtil_1 = require("../../util/StoresUtil");
const crm_components_1 = require("crm-components");
let GDPRSuccess = class GDPRSuccess extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(lib_1.Separator, { className: "hidden-xs hidden-sm", color: "invisible", spacing: "medium" }),
            react_1.default.createElement(lib_1.Grid, { align: ['center-xs', 'middle-xs', 'end-md'], equalHeight: true, reverse: ['md'] },
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'sm-9', 'md-5'] },
                    react_1.default.createElement(lib_1.Text, { className: "text-center text-left-md" },
                        react_1.default.createElement(lib_1.Heading, { element: "h1", className: "h2 text-primary" }, translate('gdpr.success.thankYou')),
                        react_1.default.createElement("p", { className: "h5" }, translate('gdpr.success.changeInfo')),
                        this.locationStore.redirectUrl ? (react_1.default.createElement(GaButton_1.default, { id: "back-to-self-service", className: "text__margin-double", text: translate('gdpr.backToSelfService'), onClick: () => this.redirect() })) : (react_1.default.createElement(lib_1.Button, { id: "logout", className: "text__margin-double", text: translate('gdpr.closeAndLogOff'), onClick: () => this.logOut() })),
                        react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "medium" }))),
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-9', 'md-4'], offset: ['md-2'] },
                    react_1.default.createElement(lib_1.Image, { srcset: "//res.cloudinary.com/telia/image/upload/w_309,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-success 309w, //res.cloudinary.com/telia/image/upload/w_618,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-success 618w", width: 309, role: "presentation", align: "center" })))));
    }
    redirect() {
        window.location.replace(this.locationStore.redirectUrl);
    }
    logOut() {
        this.ssoStore.doLogout();
        (0, crm_components_1.navigate)('/');
    }
};
GDPRSuccess = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRSuccess);
exports.default = GDPRSuccess;
